export default class Equipe {
    constructor() {
        this._items = Array.from(document.querySelectorAll('.eqp__grp__title__btn'));
        this._navHeight = 150;
        this._navHeightMobile = 70;
        this._isMobile = true;
    }
    render() {
        if (this._items.length) {
            this._items.forEach((item) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (!e.currentTarget.classList.contains('active')) {
                        e.currentTarget.classList.add('active');
                    } else {
                        e.currentTarget.classList.remove('active');
                    }
                });
            });
        }
    }

    doResize() {
        const willMobile = window.innerWidth < 960;
        if (willMobile != this._isMobile) {
            this._isMobile = willMobile;
        }
    }

    offset(el) {
        var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }

    doScrolling(elementY, duration) {
        var startingY = window.pageYOffset;
        var diff = elementY - startingY;
        var start;
        // Bootstrap our animation - it will get called right before next frame shall be rendered.
        window.requestAnimationFrame(function step(timestamp) {
            if (!start) start = timestamp;
            // Elapsed milliseconds since start of scrolling.
            var time = timestamp - start;
            // Get percent of completion in range [0, 1].
            var percent = Math.min(time / duration, 1);
            window.scrollTo(0, startingY + diff * percent);
            // Proceed with animation as long as we wanted it to.
            if (time < duration) {
                window.requestAnimationFrame(step);
            }
        });
    }
}
